module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-cogs',\n    title: 'Debug',\n    description: 'Inspect and modify Clerk internals. Only for debugging and development purposes'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/debug/debug.section-header.html
// module id = 4141
// module chunks = 86